export const MAX_LINE_ITEMS_COUNT = 20;

export const MAX_LINE_ITEMS_REACHED_TOOLTIP = 'Maximum number of line items reached.';
